import { Move3d, ZoomIn, ScanEye, ShieldCheck, Server, Moon } from 'lucide-react';
import SeriesTemplate from '../components/SeriesTemplate';

const PtzCamera = () => {
  const features = [
    {
      Icon: Move3d,
      title: 'パン・チルト操作対応',
      desc: 'カメラの向きを遠隔から調整でき、広い敷地でも状況を確認しやすくなります。',
    },
    {
      Icon: ZoomIn,
      title: '光学ズーム対応',
      desc: '離れた場所の対象を寄せて確認でき、駐車場や広い工場でも使いやすいカメラです。',
    },
    {
      Icon: ScanEye,
      title: '人・車両検知/自動追尾',
      desc: '検知した対象を自動で追尾するモデルもあり、広範囲の監視に向いています。',
    },
    {
      Icon: Moon,
      title: '夜間の確認にも対応',
      desc: '赤外線対応モデルにより、夜間・暗所での撮影にも対応します。',
    },
    {
      Icon: ShieldCheck,
      title: '屋外設置に対応',
      desc: 'IP66対応モデルがあり、屋外の広い敷地や施設外周に設置できます。',
    },
    {
      Icon: Server,
      title: 'NVR・録画機器と連携',
      desc: '複数台のPTZカメラを組み合わせて広範囲の監視構成を作れます。',
    },
  ];

  const notes = [
    'ズーム・追尾機能は設定内容や対象物により、動作範囲が異なる場合があります。',
    '設置位置により、死角や視認しにくい範囲が発生することがあります。',
    '屋外設置の場合は、配線経路・取付位置・防水処理の確認が必要です。',
    '機種や設定内容により、使用できる機能が異なる場合があります。',
  ];

  return (
    <SeriesTemplate
      id="ptz"
      eyebrow="PTZ CAMERA"
      name="PTZカメラシリーズ"
      description="カメラの向きやズームを調整できるタイプの防犯カメラです。広い駐車場、工場、倉庫、屋外設備など、広範囲を確認したい場所に向いています。"
      tags={['PTZ', '光学ズーム', '8MP', 'PoE対応', 'IP66', '夜間撮影']}
      heroImage="/images/ptz-camera.png"
      features={features}
      locations={['駐車場', '工場', '倉庫', '屋外設備', '施設外周', '広い敷地', '公共施設']}
      notes={notes}
    />
  );
};

export default PtzCamera;
